// extracted by mini-css-extract-plugin
module.exports = {"table_padding_remove":"list-of-arrangements_table_padding_remove__hnKYK"};